import React from 'react';
import { formatAmount } from '../utils/format';

import fileTextIcon from '../icons/file-textBl.svg';
import linkIcon from '../icons/linkGr.svg';
import chevronRightIcon from '../icons/chevron-right.svg';
import repairIcon from '../icons/repair.svg';

const GRID_COLS = "grid-cols-[1fr_auto_3fr]";

const Stat = ({ label, value }) => (
  <div className="text-left">
    <p className="text-[12px] text-[#707070] font-semibold">{label}</p>
    <p className="text-[16px] text-[#043F88] font-semibold">{value}</p>
  </div>
);

const MappedProductCard = ({ detail }) => {
  const product = detail.product;
  const quantity = detail.quantity ?? 0;
  const returned = detail.returned ?? 0;
  const unitPriceHT = detail.unitPrice ?? 0;
  const vatRate = detail.vatRate ?? product?.tva ?? 0;
  const discount = detail.discount ?? product?.discount ?? 0;
  const totalHT = detail.priceHT ?? (unitPriceHT * quantity);
  const totalTTC = detail.priceTTC ?? (totalHT * (1 + vatRate / 100));

  return (
    <div className="max-h-[72px] grid grid-cols-[32%_9%_11%_11%_11%_11%_15%] items-center gap-2 bg-[#0AD69E12] border border-[#0AD69F] rounded-[12px] px-4 py-3 shadow-[0px_6px_26px_rgba(98,107,125,0.07)]">
      <div className="min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <p className="text-[12px] font-semibold text-[#707070]">{product?.reference}</p>
          {detail.integratedIntoQuote && (
            <span className="text-[9px] font-bold text-white bg-[#0AD69F] rounded-[12px] px-1 py-0">
              Intégré au devis
            </span>
          )}
        </div>
        <p className="text-[#6B78F8] font-semibold text-[15px] truncate">{product?.name ?? detail.designation}</p>
      </div>
      <Stat label="QTÉ" value={quantity} />
      <Stat label="PRIX UN HT" value={formatAmount(unitPriceHT)} />
      <Stat label="TVA" value={`${vatRate}%`} />
      <Stat label="REMISE" value={`${discount}%`} />
      <Stat label="RETOURNÉ" value={returned} />
      <Stat label="TOTAL TTC" value={formatAmount(totalTTC)} />
    </div>
  );
};

const NotForProcurementRow = ({ cd }) => (
  <div className={`grid ${GRID_COLS} items-center gap-4`}>
    <div className="max-h-[72px] flex flex-col justify-center gap-1 bg-white rounded-[12px] px-5 py-3 shadow-[0px_6px_26px_rgba(98,107,125,0.07)]">
      <div className="flex items-center gap-2 min-w-0">
        <p className="text-[#043F88] font-semibold text-[16px] truncate min-w-0">{cd.product?.name ?? cd.designation}</p>
        <img src={repairIcon} alt="À réparer — ne pas acheter" title="À réparer — ne pas acheter" className="w-4 h-4 flex-shrink-0" />
      </div>
      <p className="text-[#707070] text-[14px] font-semibold">
        QUANTITÉ: <span className="text-[#043F88] ml-1">{cd.quantity}</span>
      </p>
    </div>
    <img src={chevronRightIcon} alt="" className="w-4 h-4" />
    <div className="min-h-[72px] flex items-center justify-center border border-dashed border-[#CDCBF3] bg-[#EDEDED] rounded-[12px] px-5 text-center text-[#707070]/50 text-[14px] font-medium shadow-[0px_6px_26px_#626B7D12] pointer-events-none">
      À Réparer — ne pas acheter
    </div>
  </div>
);

const MappedRow = ({ cd, detail }) => (
  <div className={`grid ${GRID_COLS} items-center gap-4`}>
    <div className="max-h-[72px] flex flex-col justify-center gap-1 bg-white rounded-[12px] px-5 py-3 shadow-[0px_6px_26px_rgba(98,107,125,0.07)]">
      <p className="text-[#043F88] font-semibold text-[16px] truncate">{cd.product?.name ?? cd.designation}</p>
      <p className="text-[#707070] text-[14px] font-semibold">
        QUANTITÉ: <span className="text-[#043F88] ml-1">{cd.quantity}</span>
      </p>
    </div>
    <img src={chevronRightIcon} alt="" className="w-4 h-4" />
    <MappedProductCard detail={detail} />
  </div>
);

const NonLivreRow = ({ cd }) => (
  <div className={`grid ${GRID_COLS} items-center gap-4`}>
    <div className="max-h-[72px] flex flex-col justify-center gap-1 bg-white rounded-[12px] px-5 py-3 shadow-[0px_6px_26px_rgba(98,107,125,0.07)]">
      <p className="text-[#043F88] font-semibold text-[16px] truncate">{cd.product?.name ?? cd.designation}</p>
      <p className="text-[#707070] text-[14px] font-semibold">
        QUANTITÉ: <span className="text-[#043F88] ml-1">{cd.quantity}</span>
      </p>
    </div>
    <img src={chevronRightIcon} alt="" className="w-4 h-4" />
    <div className="min-h-[72px] flex items-center justify-center border border-dashed border-[#CDCBF3] bg-[#EDEDED] rounded-[12px] px-5 text-center text-[#707070]/50 text-[14px] font-medium shadow-[0px_6px_26px_#626B7D12] pointer-events-none">
      Non livré
    </div>
  </div>
);

const ExtraRow = ({ detail, index }) => (
  <div key={`extra-${index}`} className={`grid ${GRID_COLS} items-center gap-4`}>
    <div className="min-h-[72px] flex items-center justify-center border border-dashed border-[#CDCBF3] bg-[#EDEDED] rounded-[12px] px-5 text-center text-[#707070]/50 text-[14px] font-medium shadow-[0px_6px_26px_#626B7D12] pointer-events-none">
      Aucune ligne sur le devis
    </div>
    <img src={chevronRightIcon} alt="" className="w-4 h-4" />
    <MappedProductCard detail={detail} />
  </div>
);

const DeliveryNoteMapping = ({ orderDetails = [], deliveryNotes = [] }) => {
  const orderDetailsById = new Map((orderDetails || []).map((cd) => [cd.id, cd]));
  const fulfilledCartDetailIds = new Set();

  const groups = (deliveryNotes || []).map((note) => {
    const mapped = [];
    const extras = [];
    (note.details || []).forEach((detail) => {
      if (detail.cartDetailId != null) {
        fulfilledCartDetailIds.add(detail.cartDetailId);
        const cd = orderDetailsById.get(detail.cartDetailId);
        if (cd) mapped.push({ cd, detail });
      } else {
        extras.push(detail);
      }
    });
    return { key: note.id, number: note.deliveryNoteNumber, mapped, extras };
  }).filter((group) => group.mapped.length > 0 || group.extras.length > 0);

  const leftover = (orderDetails || []).filter((cd) => !fulfilledCartDetailIds.has(cd.id));

  if (groups.length === 0 && leftover.length === 0) {
    return <div className="text-center py-12 text-gray-500">Aucune ligne à afficher</div>;
  }

  return (
    <div>
      <div className={`grid ${GRID_COLS} items-center gap-4 mb-2 text-[14px] font-semibold`}>
        <div className="flex items-center gap-2 text-[#4154A2]">
          <img src={fileTextIcon} alt="" className="w-4 h-4" /> Saisi sur le devis
        </div>
        <div className="w-4 h-4" />
        <div className="flex items-center gap-2 text-[#0AD69F]">
          <img src={linkIcon} alt="" className="w-4 h-4" /> Lié par le magasinier
        </div>
      </div>

      <div className="space-y-6">
        {groups.map((group) => (
          <div key={group.key}>
            <h4 className="text-[13px] font-semibold text-[#ACAFC6] mb-2">BL: {group.number}</h4>
            <div className="space-y-3">
              {group.mapped.map(({ cd, detail }) => <MappedRow key={cd.id} cd={cd} detail={detail} />)}
              {group.extras.map((detail, index) => <ExtraRow key={`extra-${index}`} detail={detail} index={index} />)}
            </div>
          </div>
        ))}

        {leftover.length > 0 && (
          <div>
            {groups.length > 0 && <h4 className="text-[13px] font-semibold text-[#ACAFC6] mb-2">NON LIVRÉ</h4>}
            <div className="space-y-3">
              {leftover.map((cd) => (
                cd.notForProcurement
                  ? <NotForProcurementRow key={cd.id} cd={cd} />
                  : <NonLivreRow key={cd.id} cd={cd} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DeliveryNoteMapping;
